var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMerch = function SvgMerch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#FFD93A",
    fillOpacity: 0.1,
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD93A",
    d: "m24.867 23.05.147.147.149-.148a1.876 1.876 0 0 1 3.2 1.326 1.876 1.876 0 0 1-.549 1.326l-2.8 2.799-2.798-2.8a1.875 1.875 0 1 1 2.651-2.65ZM20 21.666v1.666a5 5 0 0 0-5 5h-1.667a6.667 6.667 0 0 1 6.459-6.663l.208-.003Zm0-10.834a4.999 4.999 0 0 1 3.602 8.47 4.998 4.998 0 0 1-3.415 1.527l-.187.003a4.999 4.999 0 0 1-3.602-8.469 4.998 4.998 0 0 1 3.415-1.527l.187-.004Zm0 1.667a3.332 3.332 0 1 0 0 6.667 3.332 3.332 0 1 0 0-6.667Z"
  })));
};
export default SvgMerch;